import { render, staticRenderFns } from "./AuthIcon.vue?vue&type=template&id=1a1ac58b&"
import script from "./AuthIcon.vue?vue&type=script&lang=js&"
export * from "./AuthIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports